import React from "react";
import selfPhoto from "./resources/self_photo.jpg";
import experiences from "../experience.js";
import skills from "../skills.js";
import ScrollAnimation from 'react-animate-on-scroll';
import { useEffect } from "react";

function Hello() {
    useEffect(() => {
        window.scrollTo(0,0)
    },[])
    return (
        <div className="hello-content">
            <ScrollAnimation animateIn="fadeIn" delay={500} animateOnce={false}>
                <div className="intro">
                    <p className="intro-heading">
                        <ScrollAnimation animateIn="fadeIn" delay={500} animateOnce={false}>
                            A
                        </ScrollAnimation> 
                        <ScrollAnimation animateIn="fadeIn" delay={500} animateOnce={false}>
                            <span className="highlight">
                                BUSINESS
                            </span>
                        </ScrollAnimation>
                        <ScrollAnimation animateIn="fadeIn" delay={500} animateOnce={false}>
                            <span className="highlight">
                                ANALYST
                            </span>
                        </ScrollAnimation>
                        <ScrollAnimation animateIn="fadeIn" delay={500} animateOnce={false}>
                            AND
                        </ScrollAnimation>
                        <span className="highlight hover-text">
                            <ScrollAnimation animateIn="fadeIn" delay={500} animateOnce={false}>
                                INFORMATION
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="fadeIn" delay={500} animateOnce={false}>
                                VISUALIZATION
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="fadeIn" delay={500} animateOnce={false}>
                                DESIGNER
                            </ScrollAnimation>
                        </span>
                    </p>
                    <div className="intro-para">
                        <p>Hello</p>
                        <p><b>My name is Leah.</b> I am a Business Analyst by profession based in <b>India</b> with additional experience in the background of UI/UX Design and Data Science.</p>
                        <p>As a Business Analyst I perform the duties of helping business units determine solutions that drive the needed change with focus on valuable outcome, while as a Designer I design functional application designs and collect data to visualize information in a comprehensive and interesting manner.</p>
                    </div>
                </div>
            </ScrollAnimation>
            
            <hr />

            <ScrollAnimation animateIn="fadeIn" delay={500} animateOnce={false}>
                <div className="whatIDo reveal fade-bottom">
                    <p className="grey-note">WHAT I DO</p>
                    <div className="grey-line"></div>
                    <p className="whatIDo-heading">I leverage my Business Analysis skills, coupled with a Creative, Technological, and Human-Centric approach, to drive efficient delivery.</p>
                    <div className="whatIDo-para">
                        <p>I am a passionate and detail-oriented IT Business Analyst specializing in Divestments. With expertise in Data Science—spanning statistics, analysis, and modeling—and 2 years of UI/UX experience, I bring a versatile skill set to every project.</p>
                        <p>In my role, I lead cross-functional teams of 20–30 professionals across multiple workstreams, ensuring divestments are delivered within the projected scope. My strong stakeholder communication and relationship-building skills allow me to foster collaboration, streamline processes, and drive impactful results. I take pride in leveraging my advanced Excel skills to automate documentation processes, significantly reducing manual workload and boosting efficiency. Additionally, my graphic design abilities enhance stakeholder communication and team cohesion through visually engaging materials and initiatives.
                        </p>
                    </div>
                </div>
            </ScrollAnimation>
            
            <div class='scroll-hr'>
                <h2 class="scroll-text">WORK WORK WORK WORK WORK WORK WORK WORK WORK WORK WORK WORK</h2>
            </div>

            {/* EXPERIENCE */}
            <ScrollAnimation animateIn="fadeIn" delay={500} animateOnce={false}>
                <div className="block">
                    <h3 className="block-heading">EXPERIENCE</h3>
                    <div className="block-cards">
                        {experiences.map((experience, index) => {
                            return (
                            <div className="block-cards-single" key={index}>
                                <p className="title">{experience.job_title}</p>
                                <h2 className="company">{experience.company}</h2>
                                <p className="duration">{experience.duration}</p>  
                                <p className="description">{experience.description}</p> 
                            </div>
                            );
                        })}
                    </div>
                </div>
            </ScrollAnimation>
            


            {/* KNOWLEDGE & SKILLS */}
            <ScrollAnimation animateIn="fadeIn" delay={500} animateOnce={false}>
                <div className="block">
                    <h3 className="block-heading">KNOWLEDGE & SKILLS</h3>
                    <div className="block-cards">
                        {skills.map((skill, index) => {
                            return (
                            <div className="block-cards-single" key={index}>
                                <p className="title skills-title">{skill.title}</p>
                                <p className="description">{skill.content}</p> 
                            </div>
                            );
                        })}
                    </div>
                </div>
            </ScrollAnimation>
            

            {/* ABOUT */}
            <ScrollAnimation className="about-block-lines" animateIn="fadeIn" delay={500} animateOnce={false}>
                <div className="about">
                    <div className="about-content">
                        <h3 className="block-heading about-heading">ABOUT</h3>
                        <p className="description about-desc">Hi, I'm Leah. I hold a Specialisation in Data Science and am an Associate BA @Shell with a background experience in Data Science and UI/UX Design. I am passionate about Art, Career Conversations and Information Visualization! </p>
                        <p className="description about-desc">I focus on presenting familiar in a different attire with my Information Visualization skills while extracting and predicting meaningful insights from data with my Data Science skillsets. I'm always looking for new ways to improve my skillset and connect with people professionally and personally. I am a cheerful person and a keen observer who follows a strict professional routine and values quality time with my family and close ones outside of the office.</p>
                        <p className="description about-desc interests">Interests & Activities:</p>
                        <p className="description about-desc">+ Music<br />+ Cinematography<br />+ Art <br />+ Tiny House Movement</p>
                    </div>
                    <div className="about-img">
                        <img src={selfPhoto} alt="Leah Pathan Khan" />
                    </div>
                </div>
            </ScrollAnimation>
            
        </div>
        
    );
};

export default Hello;




// IMAGE HOVER & CURSOR CIRCLE
    // const link = document.querySelectorAll(".hover-text");
    // const hoverReveal = document.querySelectorAll(".hover-reveal");
    // const linkImages = document.querySelectorAll(".hidden-img");
    
    // for (let i = 0; i < link.length; i++) {
    //     link[i].addEventListener('mousemove', (e) => {
    //         hoverReveal[i].style.opacity = 1;
    //         hoverReveal[i].style.transform = `translate(-100%,-50%) rotate(5deg)`;
    //         linkImages[i].style.transform = 'scale(1, 1)';
    //         hoverReveal[i].style.left = e.clientX + "px";
    //     })
    //     link[i].addEventListener('mouseleave', (e) => {
    //         hoverReveal[i].style.opacity = 0;
    //         hoverReveal[i].style.transform = `translate(-100%,-50%) rotate(-5deg)`;
    //         linkImages[i].style.transform = 'scale(0.8,0.8)';
    //     })
    // }

    // let curs = document.querySelector('.cursor');

    // document.addEventListener('mousemove', (e) => {
    // let x = e.pageX;
    // let y = e.pageY;
    // curs.style.left = (x - 22) + "px";
    // curs.style.top = (y - 22) + "px";
    // });

    // document.addEventListener('mouseleave', (e) => {
    // let x = e.pageX;
    // let y = e.pageY;
    // curs.style.left = (x - 22) + "px";
    // curs.style.top = (y - 22) + "px";
    // });